import { getExpressionParser } from '../../modules/expressionParser';
export const createLeftParser = () => {
    const expressionParser = getExpressionParser();
    const parse = async (data) => {
        const parsedExpression = await expressionParser.parse(data.data.str.value, 'unwrap');
        const plainText = expressionParser.stripHtml(parsedExpression.value);
        const left = plainText.substring(0, parseInt(data.data.str.numOfCharacters));
        parsedExpression.value = parsedExpression.value.replace(plainText, left);
        return parsedExpression;
    };
    return {
        parse
    };
};
